export enum Variant {
  STANDARD = 'STANDARD',

  MODEL_CONTRACT = 'MODEL_CONTRACT',
}
